import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * En-tête de section façon Uber Eats: titre en gras, lien "Voir tout" optionnel,
 * et flèches précédent/suivant optionnelles pour piloter un carrousel horizontal.
 */
const SectionHeader = ({ title, onSeeAllClick, onScrollLeft, onScrollRight, canScrollLeft, canScrollRight }) => {
  const { t } = useTranslation();
  return (
    <div className="flex items-center justify-between mb-4">
      <h2 className="font-display text-xl sm:text-2xl font-bold text-namke-black">{title}</h2>
      <div className="flex items-center gap-3">
        {onSeeAllClick && (
          <button type="button" onClick={onSeeAllClick} className="text-sm font-semibold text-namke-darkGreen hover:underline">
            {t('home.seeAll')}
          </button>
        )}
        {(onScrollLeft || onScrollRight) && (
          <div className="hidden sm:flex items-center gap-2">
            <button
              type="button"
              onClick={onScrollLeft}
              disabled={!canScrollLeft}
              className="w-8 h-8 rounded-full border border-namke-darkGreen/15 bg-namke-white flex items-center justify-center disabled:opacity-40 disabled:cursor-not-allowed hover:bg-primary-50 transition-colors"
              aria-label={t('home.previous')}
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.5} strokeLinecap="round" className="w-4 h-4 text-namke-darkGreen">
                <path d="M15 18l-6-6 6-6" />
              </svg>
            </button>
            <button
              type="button"
              onClick={onScrollRight}
              disabled={!canScrollRight}
              className="w-8 h-8 rounded-full border border-namke-darkGreen/15 bg-namke-white flex items-center justify-center disabled:opacity-40 disabled:cursor-not-allowed hover:bg-primary-50 transition-colors"
              aria-label={t('home.next')}
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.5} strokeLinecap="round" className="w-4 h-4 text-namke-darkGreen">
                <path d="M9 18l6-6-6-6" />
              </svg>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SectionHeader;
